import client from "@sanity/client"

export default client ({
    projectId:"dmymev9x",
    dataset: "production",
    useCdn: true,
    apiVersion: "2021-10-21"
})